<template>
  <div class="container">
    <el-table height="400" border fit style="width:100%;text-align: center;" :data="currentRecordDetails">
      <el-table-column prop="name" label="菜名" width="180">
      </el-table-column>
      <el-table-column prop="price" label="价格" width="180">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import qs from "qs";
export default {
  data() {
    return {
      currentRecordDetails: null,
      host: "",
      testHost: 'http://47.99.142.73:7705/'
    };
  },
  mounted() {
    this.record_id = query.record_id;
    this.getDetails();
  },
  methods: {
    getDetails() {
      this.$http
        .post(
          `${this._host}salerecord/detail/query/`,
          qs.stringify({ record_id: this.record_id }),
          {
            headers: {
              "api-key": this.api_key,
              "Content-Type": "application/x-www-form-urlencoded"
            }
          },
          { emulateHTTP: true }
        )
        .then(res => {
          this.currentRecordDetails = res.body.data;
        })
        .catch(e => {
        
        });
        this.http.post(`${this._host}path`,
          {body},
          {header}
        ).then( res => {})
    }
  },
  computed: {
    userinfo () {
      return this.$store.getters.userinfo()
    },
    api_key () {
      return this.userinfo.api_key
    },
}
};
</script>
<style>
</style>
